import { render, staticRenderFns } from "./addsubject.vue?vue&type=template&id=23cf6634&scoped=true&"
import script from "./addsubject.vue?vue&type=script&lang=js&"
export * from "./addsubject.vue?vue&type=script&lang=js&"
import style0 from "./addsubject.vue?vue&type=style&index=0&id=23cf6634&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf6634",
  null
  
)

export default component.exports